// Un cuadro de texto que crece con lo que se escribe: la celda de una tabla no corta el texto ni muestra barras ni la
// flechita de agrandar del navegador. Tope de alto: pasado eso, se desplaza adentro.
import { useLayoutEffect, useRef } from 'react';

const ALTO_MAXIMO = 260;

export function AreaQueCrece(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const ref = useRef<HTMLTextAreaElement>(null);
  const { value } = props;
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    // En un entorno sin layout (pruebas) `scrollHeight` es 0: no se toca la altura.
    if (el.scrollHeight > 0) {
      el.style.height = `${Math.min(el.scrollHeight + 2, ALTO_MAXIMO)}px`;
      el.style.overflowY = el.scrollHeight + 2 > ALTO_MAXIMO ? 'auto' : 'hidden';
    }
  }, [value]);
  return <textarea ref={ref} rows={1} {...props} />;
}
